import { RouteConfig } from 'vue-router'

interface PermissionNode {
  id: string
  name: string
  children?: PermissionNode[]
}
// 新增路径规范化函数
const normalizePath = (path: string) => {
  return path
    .replace(/^\/+/g, '')  // 移除开头斜杠
    .replace(/\/+$/g, '')  // 移除结尾斜杠
    .replace(/\/+/g, '/'); // 合并连续斜杠
};

export function generatePermissionTree(routes: RouteConfig[]): PermissionNode[] {
  const permissionTree: PermissionNode[] = []

  
  function processRoute(route: RouteConfig, parentPath: string = ''): PermissionNode | null {
    // 跳过不需要权限验证的路由
    if (route.meta && route.meta.without_auth) {
      console.log('Skipping route without auth:', route.path)
      return null
    }

    // 跳过首页路由
    // if (route.path === 'home') {
    //   console.log('Skipping home route')
    //   return null
    // }

    // 处理路径，确保使用相对路径
    const currentPath = parentPath ? `${parentPath}/${route.path}` : route.path
    const node: PermissionNode = {
      id: currentPath,
      name: route.meta?.title || route.meta?.titleEdit || route.name || '未命名路由'
    }

    console.log('Processing route:', {
      path: currentPath,
      name: node.name,
      meta: route.meta,
      hasChildren: !!route.children
    })

    // 处理子路由
    if (route.children && route.children.length > 0) {
      const validChildren = route.children
        .map(child => processRoute(child, currentPath))
        .filter(Boolean) as PermissionNode[]

      if (validChildren.length > 0) {
        node.children = validChildren
      }
    }

    // 如果路由有名称或者有子节点，就返回
    if (node.name !== '未命名路由' || (node.children && node.children.length > 0)) {
      return node
    }

    console.log('Skipping route without name or children:', route.path)
    return null
  }

  console.log('Starting to generate permission tree from routes:', routes)
  
  // 处理根路由的 children
  if (routes[0] && routes[0].children) {
    routes[0].children.forEach(route => {
      const node = processRoute(route)
      if (node) {
        permissionTree.push(node)
      }
    })
  }

  console.log('Generated permission tree:', permissionTree)
  return permissionTree
}

// 根据权限过滤路由
export function filterRoutesByPermissions(routes: RouteConfig[], permissions: string): RouteConfig[] {
  // 如果权限为空，返回所有路由
  if (permissions.trim() === '') {
    return []
  }
  if (!permissions || permissions.trim() === '*') {
    // console.log('No permissions provided, showing all routes');
    return routes;
  }

  const permissionList = (permissions.split(',') || []).map(normalizePath);
  
  // 检查路由权限
  const hasPermission = (route: RouteConfig, parentPath: string = ''): boolean => {
    // 如果路由不需要权限验证，直接返回 true
    if (route.meta && route.meta.without_auth) {
      return true;
    }
    
    // // 首页路由始终允许访问
    // if (route.path === 'home') {
    //   return true;
    // }
    
    // 构建完整路径
    const fullPath = parentPath ? `${parentPath}/${route.path}` : route.path;
    const routePath = normalizePath(fullPath);
    
    // 检查路由路径是否在权限列表中
    return permissionList.includes(routePath);
  };
  
  const filterRoutes = (routes: RouteConfig[], parentPath: string = ''): RouteConfig[] => {
    return routes
      .map(route => {
        const currentPath = parentPath ? `${parentPath}/${route.path}` : route.path;
        const newRoute = { ...route };
        
        if (route.children) {
          newRoute.children = filterRoutes(route.children, currentPath);
        }
        
        return newRoute;
      })
      .filter(route => {
        const isSelfAllowed = hasPermission(route, parentPath);
        const hasValidChildren = route.children?.some(child => 
          hasPermission(child, parentPath ? `${parentPath}/${route.path}` : route.path)
        );
        
        return isSelfAllowed || (hasValidChildren && route.children?.length);
      });
  };

  return filterRoutes(routes);
}

// 获取路由的完整路径
function getFullPath(route: RouteConfig, parentPath: string = ''): string {
  // 移除开头的斜杠，确保使用相对路径
  const path = route.path.startsWith('/') ? route.path.slice(1) : route.path
  const fullPath = parentPath ? `${parentPath}/${path}` : path
  return fullPath
} 